var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":"500","title":"短信RM设置N9运维网络","ok-text":"发送"},on:{"on-visible-change":_vm.visibleChange,"on-ok":_vm.onOk},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},[_c('p',[_vm._v("确认发送短信：锐明设备设置N9运维网络")])])
}
var staticRenderFns = []

export { render, staticRenderFns }